import { render, staticRenderFns } from "./ModalCreateNovietisAdmin.vue?vue&type=template&id=515f740a"
import script from "./ModalCreateNovietisAdmin.vue?vue&type=script&lang=js"
export * from "./ModalCreateNovietisAdmin.vue?vue&type=script&lang=js"
import style0 from "./ModalCreateNovietisAdmin.vue?vue&type=style&index=0&id=515f740a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports